var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.active > 0,"absolute":"","opacity":"0.4","color":"grey"}},[_c('v-flex',{attrs:{"text-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"accent","size":"128","width":"12"},on:{"click":function($event){_vm.active = 0}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }